export default {
  root: {
    padding: [80, 0],
  },
};
